import React from 'react'
import { FormGroup } from 'react-bootstrap'
import { find } from 'lodash'
import { replaceExpression, isEmptyValue } from '../utils'

import IconTooltip from './IconTooltip'
import Collaboration from './Collaboration'
import CheckmarkQuestionAnswered from './CheckmarkQuestionAnswered'

import { CollaboratorsContext } from '../context/CollaboratorsContext'

function TableColumn(props) {
    const { option, onChange, answermap, optionIds, value, selectValues, originalValue } = props
    return (
        <div className="col">
            <div className="form-numeric form-numeric-inline">
                {replaceExpression(option.optionText, answermap) &&
                    <div className="text">{replaceExpression(option.optionText, answermap)}</div>}
                <select name={option.id} value={value} onChange={e => onChange(e, optionIds, option)}>
                    <option default>Selecteer een aantal</option>
                    {selectValues}
                </select>
                {originalValue && <span className="original">{originalValue}</span>}
            </div>
        </div>
    )
}

export default class SelectQuestion extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = { rows: [] }
    }


    obtainAnsweredCheckDOM(optionIds) {
      let questionHasAnswer = true

      optionIds.forEach(id => {
        const value = this.getValue(id)
        if (isEmptyValue(value)) {
          questionHasAnswer &= false
        }
      })

      return (
        <CheckmarkQuestionAnswered checked={questionHasAnswer} />
      )
    }

    getValue(optionId) {
        const value = find(this.props.state, s => s.optionId === optionId)
        return value ? value.stringValue : ""
    }

    getOriginalValue(optionId) {
        let value = undefined

        if (this.props.originalState) {
            value = find(this.props.originalState, s => s.optionId === optionId)
        }
        return value ? value.booleanValue : false
    }

    getSelectOptions(optionSelectValues, answermap) {
        let items = [];
        JSON.parse(optionSelectValues, (k, v) => {
            if (k) {
                let rev = replaceExpression(v, answermap)
                rev = rev.replace("per patiënten", "per patiënt");
                rev = rev.replace("per cliënten", "per cliënt");
                rev = rev.replace("per bewoners", "per bewoner");
                rev = rev.replace("1 patiënten", "1 patiënt");
                rev = rev.replace("1 cliënten", "1 cliënt");
                rev = rev.replace("1 bewoners", "1 bewoner");
                items.push(<option key={k} value={k}>{rev}</option>)
            }
        })
        return items
    }

    componentDidMount() {
        this.prepareTable(this.props.data)
    }

    prepareTable(question) {
        let currentRow = { row: 0 }
        let rows = []

        question.options.map(option => {
            if (currentRow.row !== option.row) {
                currentRow = { row: option.row, columns: [] }
                rows.push(currentRow)
            }
            return currentRow.columns.push(option)
        })
        this.setState({ rows: rows })
    }

    render() {
        const { data, completed, onChange, answermap, isIntroQuestions } = this.props
        const { rows } = this.state
        const optionIds = data.options.map(option => option.id)

        return (
            <div className="question-group type-numeric row">
                <div className="col">
                    <form>
                        <span>{replaceExpression(data.questionText, answermap)} <IconTooltip
                            text={replaceExpression(data.explanation, answermap)} icon="far fa-info-circle" />
                            <div className="indicator-container">
                              {this.obtainAnsweredCheckDOM(optionIds)}
                            </div>
                        </span>
                        <FormGroup>
                            <div>
                                {
                                    rows.map(row => (
                                        <div className="row" key={row.row}>{
                                            row.columns.map(option => (
                                                <TableColumn
                                                    key={option.column}
                                                    option={option}
                                                    completed={completed}
                                                    onChange={(e, optionId) => onChange(e, option.id, optionId)}
                                                    answermap={answermap}
                                                    optionIds={optionIds}
                                                    value={this.getValue(option.id)}
                                                    selectValues={this.getSelectOptions(option.optionSelectValues, answermap)}
                                                    originalValue={this.getOriginalValue(option.id)} />
                                            ))
                                        }</div>
                                    ))
                                }
                            </div>
                        </FormGroup>
                    </form>
                </div>
                {!isIntroQuestions &&
                    <CollaboratorsContext.Consumer>
                        {context => (<Collaboration data={data}
                            answermap={answermap}
                            collaborators={context.state.collaborators}
                            scanId={context.state.scanId} />)}
                    </CollaboratorsContext.Consumer>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectQuestion.js